// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container__onH_c"};